import { Routes } from '@angular/router';
import { SuperAdminSigninComponent } from './features/auth/super-admin-signin/super-admin-signin';
import { dashboardGuestGuard, dashboardRoleGuard } from 'sham-components/services';
export const routes: Routes = [
  {
    path: 'login',
    canActivate: [dashboardGuestGuard('Admin', ['/app'])],
    component: SuperAdminSigninComponent,
  },
  { path: 'admin/login', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'staff-password-reset/:email/:token',
    data: { passwordReset: true },
    loadComponent: () =>
      import('./features/staff/accept-staff-invitation/accept-staff-invitation.component').then(
        (x) => x.AcceptStaffInvitationComponent,
      ),
  },
  {
    path: 'reset-password/:userId/:email/:token',
    loadComponent: () =>
      import('./features/staff/accept-staff-invitation/accept-staff-invitation.component').then(
        (x) => x.AcceptStaffInvitationComponent,
      ),
  },
  {
    path: 'app',
    canActivate: [dashboardRoleGuard('Admin', ['/login'])],
    canActivateChild: [dashboardRoleGuard('Admin', ['/login'])],
    loadComponent: () =>
      import('./layouts/dashboard/dashboard').then((x) => x.Dashboard),
    loadChildren: () => import('./shared/dashboard-routes'), // هذا الملف هو الذي يجب أن يحتوي على كل المسارات الفرعية
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
];
